import script from "./DashWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./DashWidget.vue?vue&type=script&setup=true&lang=js"

import "./DashWidget.vue?vue&type=style&index=0&id=0a2caa4c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a2caa4c"]])

export default __exports__